var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-password-icon",on:{"click":function($event){return _vm.switchPasswordInputType($event)}}},[_c('font-awesome-icon',{staticStyle:{"pointer-events":"none"},attrs:{"icon":_vm.buttonIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }